import React from 'react';
import './bannerNotification.css';

import { node, oneOf, func, string, bool } from 'prop-types';

export const BannerNotification = (props) => {
  const { notificationStyle, children, title, onClose, showClose, showIcon } = props;

  return (
    <section id='js-notifications-group' className='c-notifications-group  js-panelgroup'>
      <div className='c-notification__container  js-notification-container'>
        <div className={`c-notification  c-notification--${notificationStyle}`}>
          <div className='c-notification__outer-wrap'>
            <div className='c-notification__inner-wrap'>
              {showIcon && <i className='c-notification__status-icon' aria-hidden='true' role='img'></i>}
              <div className='c-notification__content'>
                {title && <h3 className='c-notification__title'>{title}</h3>}
                {children && <div className='c-notification__text'>{children}</div>}
              </div>
              {showClose && (
                <button
                  className='js-notification-close c-notification__close'
                  aria-label='Close'
                  type='submit'
                  onClick={onClose}
                  data-testid='notification-close'
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

BannerNotification.propTypes = {
  notificationStyle: oneOf(['info', 'success', 'warning', 'error', 'custom']).isRequired,
  children: node.isRequired,
  title: string,
  showClose: bool,
  onClose: func,
  showIcon: bool,
};

BannerNotification.defaultProps = {
  onClose: () => { },
  title: '',
  showClose: false,
  showIcon: false,
};

export default BannerNotification;
